import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  viewChild,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { asNonNull } from '@kaseya-utils';

@Component({
  selector: 'itc-auth-container',
  templateUrl: 'auth-container.component.html',
  styleUrl: 'auth-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthContainerComponent implements AfterViewInit, OnDestroy {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private resizeObserver: ResizeObserver;
  private window: Window;

  readonly contentContainer = viewChild.required<ElementRef<HTMLDivElement>>('contentContainer');
  readonly logoContainer = viewChild.required<ElementRef<HTMLDivElement>>('logoContainer');

  isFormLongerThanScreen: boolean;

  constructor() {
    this.window = asNonNull(this.document.defaultView);
  }

  ngAfterViewInit(): void {
    this.registerResizeObserver();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private registerResizeObserver(): void {
    this.resizeObserver = new ResizeObserver(() => {
      this.onResizeEvent();
    });
    this.resizeObserver.observe(this.document.body);
  }

  private onResizeEvent(): void {
    this.calculateFormFitsScreen();
    this.changeDetectorRef.detectChanges();
  }

  private calculateFormFitsScreen(): void {
    this.isFormLongerThanScreen = this.contentHeight < this.window.innerHeight - this.logoHeight * 2;
  }

  private get contentHeight(): number {
    return (this.contentContainer().nativeElement.firstChild as HTMLElement).offsetHeight;
  }

  private get logoHeight(): number {
    return (this.logoContainer().nativeElement.firstChild as HTMLElement)?.offsetHeight;
  }
}
